import React, { useEffect } from 'react';
import type { PreloadedQuery } from 'react-relay';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src';
import type { mainCodeInJiraUpdatedQuery as MainCodeInJiraUpdatedPreloadedQuery } from '@atlassian/jira-relay/src/__generated__/mainCodeInJiraUpdatedQuery.graphql';
import type { TenantContext } from '@atlassian/jira-shared-types';
import { useCodeLocalStore } from './controllers/code-local-store';
import { useQueryParamSync } from './controllers/query-param-sync';
import DefaultPage from './ui';
import LoadingPage from './ui/loading';

export type Props = {
	tenantContext: TenantContext;
	initialQueryReference: PreloadedQuery<MainCodeInJiraUpdatedPreloadedQuery>;
};

export const CodeMainPage = ({ tenantContext, initialQueryReference }: Props) => {
	useQueryParamSync();

	const projectContext = useProjectContext();

	const [, localActions] = useCodeLocalStore();

	useEffect(() => {
		if (projectContext.data) {
			localActions.setProjectContext(projectContext.data);
		}
	}, [projectContext.data, localActions]);

	if (!projectContext.data) {
		return <LoadingPage />;
	}

	return (
		<DefaultPage
			cloudId={tenantContext.cloudId}
			initialQueryReference={initialQueryReference}
			isAdmin={tenantContext.isAdmin}
			projectContext={projectContext.data}
		/>
	);
};
